export default __webpack_public_path__ + "static/media/failure_modavat_24_enabled.c78bb1e8.svg";